import React, { Component } from 'react'
import { compose, withProps } from 'recompose'
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  KmlLayer
} from 'react-google-maps'

const Map = compose(
  withProps({
    // googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_API_KEY}`,
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=AIzaSyC5xp4uPYi7k_3D-SO_LDdcjY2fOo8tI-o`,
    loadingElement: <div style={{ height: `80%` }} />,
    containerElement: <div style={{ height: `80vh`, paddingTop: '2vh' }} />,
    mapElement: <div style={{ height: `100%` }} />
  }),
  withScriptjs,
  withGoogleMap
)(props => {
  const { source } = props

  console.log(source)
  const renderKmlLayer = source.map((item, index) => {
    return (
      <KmlLayer key={index} url={item} options={{ preserveViewport: true }} />
    )
  })

  return (
    <GoogleMap
      defaultZoom={2}
      defaultCenter={{ lat: 37.1997, lng: -76.37694999999999 }}
      mapTypeId={'terrain'}
    >
      {renderKmlLayer}
    </GoogleMap>
  )
})

export default Map
